<!-- 缴费账单查询内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode": "2KKN6112",
                "dimension": "2",
                "startTime": "2018-12-04 00:00:00",
                "endTime": "2018-12-04 23:59:59",
                "pageNum": "1",
                "pageSize": "10"
            },
            responseCode: {
    "data": {
        "currCount": 4,
        "recordList": [
            {
                "day": 13,
                "month": 9,
                "parkCode": "2KKN6112",
                "payCount": 3,
                "payMode": 5,
                "payTotal": 0.03,
                "statDate": "2018-09-13",
                "year": 2018
            },
            {
                "day": 30,
                "month": 8,
                "parkCode": "2KKN6112",
                "payCount": 16,
                "payMode": 19,
                "payTotal": 15.54,
                "statDate": "2018-08-30",
                "year": 2018
            },
            {
                "day": 22,
                "month": 5,
                "parkCode": "2KKN6112",
                "payCount": 131,
                "payMode": 9,
                "payTotal": 731.55,
                "statDate": "2018-05-22",
                "year": 2018
            },
            {
                "day": 17,
                "month": 5,
                "parkCode": "2KKN6112",
                "payCount": 388,
                "payMode": 1,
                "payTotal": 2997.66,
                "statDate": "2018-05-17",
                "year": 2018
            }
        ],
        "total": 4,
        "totalPayCount": 538,
        "totalPayMoney": 3744.78
    },
    "message": "业务成功",
    "resultCode": 0,
    "status": 1
}
,
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取某停车场缴费账单信息",
                t_url: this.commonUrls.test+"getBillSummary",
                p_url: this.commonUrls.prod+"getBillSummary",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'dimension', info2: '是', info3: 'Integer', info4: '时间维度 0天 1月 2年 3自定义' },
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '时间段起始时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '时间段结束时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'pageNum', info2: '是', info3: 'Integer', info4: '第几页，从1开始' },
                        { info1: 'pageSize', info2: '是', info3: 'Integer', info4: '每页多少条，最多1000条' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'total', info2: '是', info3: 'Integer', info4: '记录总数' },
                        { info1: 'currCount', info2: '是', info3: 'Integer', info4: '当前获取的记录数' },
                        { info1: 'totalPayCount', info2: '是', info3: 'Integer', info4: '总交易笔数' },
                        { info1: 'totalPayMoney', info2: '是', info3: 'Decimal', info4: '总交易金额' },
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '支付账单信息列表' }
                        ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编码' },
                        { info1: 'statDate', info2: '否', info3: 'String', info4: '统计日期' },
                        { info1: 'year', info2: '是', info3: 'Integer', info4: '统计日期日' },
                        { info1: 'month', info2: '是', info3: 'Integer', info4: '统计日期月' },
                        { info1: 'day', info2: '是', info3: 'Integer', info4: '统计日期年' },
                        { info1: 'payMode', info2: '是', info3: 'Integer', info4: '支付方式（<url>参考附录:/Api/appendixData</url>）' },
                        { info1: 'payCount', info2: '否', info3: 'Integer', info4: '支付方式账单笔数' },
                        { info1: 'payTotal', info2: '是', info3: 'Decimal', info4: '支付方式账单总额' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/dataAnalysis/getBillSummary.vue